module.exports = __webpack_public_path__ + "static/media/undo.1b7dc0b0.svg";